module.exports = __webpack_public_path__ + "img/popovich.f6e8ff2b.png";